export default (whatsapp, mensagem) => {
    const urlBase = 'https://api.whatsapp.com/send?phone=+55'
    const url = `${urlBase}${whatsapp}&text=`
    
    return `${url}${mensagem}`

}